import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "user-form email-setts"
}
const _hoisted_3 = { class: "user-form profile-form" }
const _hoisted_4 = { class: "row h2" }
const _hoisted_5 = { class: "col-md-6 col-sm-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-lines-fill" }, null, -1)
const _hoisted_7 = { class: "d-flex justify-content-end col-md-6 col-sm-12" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clearboth" }, null, -1)
const _hoisted_10 = { class: "setting-data" }
const _hoisted_11 = { class: "row align-items-center" }
const _hoisted_12 = { class: "col-md-6 col-sm-12 mb-0" }
const _hoisted_13 = { class: "col-md-6 col-sm-12 d-flex justify-content-end" }
const _hoisted_14 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_15 = {
  href: "javascript:;",
  class: "dropdown-toggle btn-xs",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-printer-fill" }, null, -1)
const _hoisted_17 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-printer-fill" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-printer" }, null, -1)
const _hoisted_20 = { class: "table" }
const _hoisted_21 = { class: "d-block d-md-none" }
const _hoisted_22 = { class: "d-block my-3" }
const _hoisted_23 = { class: "d-none d-md-block" }
const _hoisted_24 = { class: "d-none t-d-md-table-cell" }
const _hoisted_25 = { class: "d-none t-d-md-table-cell" }
const _hoisted_26 = { class: "d-none t-d-md-table-cell" }
const _hoisted_27 = { class: "d-none t-d-md-table-cell" }
const _hoisted_28 = { class: "d-none t-d-md-table-cell" }
const _hoisted_29 = { class: "d-none t-d-md-table-cell" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("th", { class: "d-none t-d-md-table-cell" }, null, -1)
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { colspan: "8" }
const _hoisted_33 = { class: "text-center py-2" }
const _hoisted_34 = {
  "show-md": "",
  "show-lg": "",
  "hide-sm": "",
  "hide-xs": "",
  class: "d-none d-md-block"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  "show-sm": "",
  "show-xs": "",
  "hide-md": "",
  "hide-lg": "",
  class: "d-block d-md-none",
  style: {"position":"relative"}
}
const _hoisted_37 = { style: {"padding":"5px 0"} }
const _hoisted_38 = { class: "bold" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { style: {"padding":"5px 0"} }
const _hoisted_41 = { class: "bold" }
const _hoisted_42 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_43 = {
  class: "dropdown-toggle",
  href: "javascript:;",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_44 = { class: "dropdown-menu" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-phone-fill" }, null, -1)
const _hoisted_47 = ["onClick"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-telephone-fill" }, null, -1)
const _hoisted_49 = { style: {"padding":"5px 0"} }
const _hoisted_50 = { class: "bold" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { style: {"padding":"5px 0"} }
const _hoisted_53 = { class: "bold" }
const _hoisted_54 = { style: {"padding":"5px 0"} }
const _hoisted_55 = { class: "bold" }
const _hoisted_56 = { style: {"padding":"5px 0"} }
const _hoisted_57 = { class: "bold" }
const _hoisted_58 = { style: {"padding":"5px 0"} }
const _hoisted_59 = { class: "bold" }
const _hoisted_60 = { class: "discl-menu dropdown pos-abs-top-right not-large" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:;",
  class: "discl-menu-caret dropdown-toggle",
  id: "dropBrok1",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, null, -1)
const _hoisted_62 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropBrok1"
}
const _hoisted_63 = ["onClick"]
const _hoisted_64 = ["onClick"]
const _hoisted_65 = /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
const _hoisted_66 = ["onClick"]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-printer-fill" }, null, -1)
const _hoisted_68 = { class: "d-none t-d-md-table-cell" }
const _hoisted_69 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_70 = {
  class: "dropdown-toggle no-dropdown-symb",
  href: "javascript:;",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_71 = { class: "dropdown-menu" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-phone-fill" }, null, -1)
const _hoisted_74 = ["onClick"]
const _hoisted_75 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-telephone-fill" }, null, -1)
const _hoisted_76 = { class: "d-none t-d-md-table-cell" }
const _hoisted_77 = ["onClick"]
const _hoisted_78 = { class: "d-none t-d-md-table-cell" }
const _hoisted_79 = { class: "d-none t-d-md-table-cell" }
const _hoisted_80 = { class: "d-none t-d-md-table-cell" }
const _hoisted_81 = { class: "d-none t-d-md-table-cell" }
const _hoisted_82 = { class: "d-none t-d-md-table-cell" }
const _hoisted_83 = { class: "sett-small-menu align-right" }
const _hoisted_84 = { class: "discl-menu dropdown" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("a", {
  class: "discl-menu-caret dropdown-toggle",
  href: "javascript:void(0)",
  role: "button",
  id: "dropdownMenuLink",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, null, -1)
const _hoisted_86 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropdownMenuLink"
}
const _hoisted_87 = ["onClick"]
const _hoisted_88 = ["onClick"]
const _hoisted_89 = /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
const _hoisted_90 = ["onClick"]
const _hoisted_91 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-printer-fill" }, null, -1)
const _hoisted_92 = { class: "col-md-6 col-sm-12" }
const _hoisted_93 = { class: "area-info" }
const _hoisted_94 = { class: "col-md-6 col-sm-12" }
const _hoisted_95 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_jw_pager = _resolveComponent("jw-pager")!
  const _component_printer_dialog = _resolveComponent("printer-dialog")!
  const _component_sms_sender_modal = _resolveComponent("sms-sender-modal")!
  const _component_email_sender_modal = _resolveComponent("email-sender-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isStillLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fa', 'fa-spinner'],
            class: "fs-1"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode("  " + _toDisplayString(_ctx.language.customers), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control input-sm",
                    placeholder: _ctx.language.search.toLowerCase(),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.customerSearchKey) = $event))
                  }, null, 8, _hoisted_8), [
                    [_vModelText, _ctx.customerSearchKey]
                  ])
                ])
              ])
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.language.list_of_customers_msg), 1),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.language.customers), 1),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddCustomerAction(0, null)))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'plus'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.new), 1)
                  ]),
                  _createTextVNode("  "),
                  (_ctx.listOfCustomers.length > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                        _createElementVNode("a", _hoisted_15, [
                          _hoisted_16,
                          _createTextVNode(" " + _toDisplayString(_ctx.language.print), 1)
                        ]),
                        _createElementVNode("span", _hoisted_17, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:;",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printListItems()))
                          }, [
                            _hoisted_18,
                            _createTextVNode(" " + _toDisplayString(_ctx.language.print_list), 1)
                          ]),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:;",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.printItemsSituation()))
                          }, [
                            _hoisted_19,
                            _createTextVNode(" " + _toDisplayString(_ctx.language.print_situation), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.refreshList()))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'refresh'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.refresh), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_20, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, [
                    _createElementVNode("span", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.language.customers), 1)
                    ]),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.language.name), 1)
                  ]),
                  _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.language.phone), 1),
                  _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.language.email), 1),
                  _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.language.city), 1),
                  _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.language.sex), 1),
                  _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.language.language), 1),
                  _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.language.origin), 1),
                  _hoisted_30
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.listOfCustomers.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                      _createElementVNode("td", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.language.no_rec_fnd), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customersPageElts, (recCust) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "acct-cal-verified",
                    key: recCust.IdClient
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_34, [
                        _createElementVNode("a", {
                          href: "javascript:;",
                          onClick: ($event: any) => (_ctx.showAddCustomerAction(1, recCust))
                        }, _toDisplayString(recCust.ClientName), 9, _hoisted_35)
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.language.name) + ": ", 1),
                          _createTextVNode("  "),
                          _createElementVNode("a", {
                            href: "javascript:;",
                            onClick: ($event: any) => (_ctx.showAddCustomerAction(1, recCust))
                          }, _toDisplayString(recCust.ClientName), 9, _hoisted_39)
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.language.phone) + ":", 1),
                          _createTextVNode("  "),
                          (recCust.Phone)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                                _createElementVNode("a", _hoisted_43, _toDisplayString(recCust.Phone), 1),
                                _createElementVNode("ul", _hoisted_44, [
                                  _createElementVNode("li", null, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      href: "javascript:;",
                                      onClick: ($event: any) => (_ctx.sendSms(recCust))
                                    }, [
                                      _hoisted_46,
                                      _createTextVNode(" " + _toDisplayString(_ctx.language.send_sms), 1)
                                    ], 8, _hoisted_45)
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      href: "javascript:;",
                                      onClick: ($event: any) => (_ctx.makeCall(recCust.Phone))
                                    }, [
                                      _hoisted_48,
                                      _createTextVNode(" " + _toDisplayString(_ctx.language.make_call), 1)
                                    ], 8, _hoisted_47)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.language.email) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, [
                            _createElementVNode("a", {
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.sendEmail(recCust))
                            }, _toDisplayString(recCust.Email), 9, _hoisted_51)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.language.city) + ":", 1),
                          _createTextVNode(" "),
                          _createElementVNode("span", null, _toDisplayString(recCust.City), 1)
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.language.sex) + ":", 1),
                          _createTextVNode(" "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.getSexText(recCust.Sex)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.language.language) + ":", 1),
                          _createTextVNode(" "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.getLangName(recCust.ClientLang)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.language.origin) + ":", 1),
                          _createTextVNode(" "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.appFxs.getCustomerOrigin(recCust.ClientOrigin)), 1)
                        ]),
                        _createElementVNode("span", _hoisted_60, [
                          _hoisted_61,
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.showAddCustomerAction(1, recCust))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'edit'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                            ], 8, _hoisted_63),
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.deleteCustomerRecord(recCust))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'trash'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.delete), 1)
                            ], 8, _hoisted_64),
                            _hoisted_65,
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.printElementSit(recCust))
                            }, [
                              _hoisted_67,
                              _createTextVNode(" " + _toDisplayString(_ctx.language.situation), 1)
                            ], 8, _hoisted_66)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_68, [
                      (recCust.Phone)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_69, [
                            _createElementVNode("a", _hoisted_70, _toDisplayString(recCust.Phone), 1),
                            _createElementVNode("ul", _hoisted_71, [
                              _createElementVNode("li", null, [
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  href: "javascript:;",
                                  onClick: ($event: any) => (_ctx.sendSms(recCust))
                                }, [
                                  _hoisted_73,
                                  _createTextVNode(" " + _toDisplayString(_ctx.language.send_sms), 1)
                                ], 8, _hoisted_72)
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  href: "javascript:;",
                                  onClick: ($event: any) => (_ctx.makeCall(recCust.Phone))
                                }, [
                                  _hoisted_75,
                                  _createTextVNode(" " + _toDisplayString(_ctx.language.make_call), 1)
                                ], 8, _hoisted_74)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_76, [
                      _createElementVNode("a", {
                        href: "javascript:;",
                        onClick: ($event: any) => (_ctx.sendEmail(recCust))
                      }, _toDisplayString(recCust.Email), 9, _hoisted_77)
                    ]),
                    _createElementVNode("td", _hoisted_78, _toDisplayString(recCust.City), 1),
                    _createElementVNode("td", _hoisted_79, _toDisplayString(_ctx.getSexText(recCust.Sex)), 1),
                    _createElementVNode("td", _hoisted_80, _toDisplayString(_ctx.getLangName(recCust.ClientLang)), 1),
                    _createElementVNode("td", _hoisted_81, _toDisplayString(_ctx.appFxs.getCustomerOrigin(recCust.ClientOrigin)), 1),
                    _createElementVNode("td", _hoisted_82, [
                      _createElementVNode("div", _hoisted_83, [
                        _createElementVNode("span", _hoisted_84, [
                          _hoisted_85,
                          _createElementVNode("div", _hoisted_86, [
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.showAddCustomerAction(1, recCust))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-edit'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                            ], 8, _hoisted_87),
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.deleteCustomerRecord(recCust))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-trash'] }),
                              _createTextVNode("  " + _toDisplayString(_ctx.language.delete), 1)
                            ], 8, _hoisted_88),
                            _hoisted_89,
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.printElementSit(recCust))
                            }, [
                              _hoisted_91,
                              _createTextVNode(" " + _toDisplayString(_ctx.language.situation), 1)
                            ], 8, _hoisted_90)
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["row margin-to-15", {'d-none': _ctx.listOfCustomers.length==0}])
            }, [
              _createElementVNode("div", _hoisted_92, [
                _createElementVNode("div", _hoisted_93, [
                  _createTextVNode(_toDisplayString(_ctx.language.total_entries) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.listOfCustomers.length), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_94, [
                _createElementVNode("nav", _hoisted_95, [
                  _createVNode(_component_jw_pager, {
                    items: _ctx.filteredCustomers,
                    initialPage: 1,
                    pageSize: _ctx.itemsPerPage,
                    maxPages: 10,
                    onChangePage: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onPageChange($event)))
                  }, null, 8, ["items", "pageSize"])
                ])
              ])
            ], 2)
          ])
        ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#modals-container" }, [
      _createVNode(_component_printer_dialog, {
        visible: _ctx.isPrintvisible,
        onCloseForm: _ctx.onPrintClose,
        printBaseData: _ctx.printInitialValues,
        extraPrintData: _ctx.printExtraData
      }, null, 8, ["visible", "onCloseForm", "printBaseData", "extraPrintData"]),
      _createVNode(_component_sms_sender_modal, {
        visible: _ctx.isSmsDlgVis,
        phoneNumber: _ctx.customerPhoneNbr,
        onCloseForm: _ctx.onCloseSmsDialog
      }, null, 8, ["visible", "phoneNumber", "onCloseForm"]),
      _createVNode(_component_email_sender_modal, {
        visible: _ctx.isEmailDlgVis,
        firstRecipients: _ctx.recipientEmails,
        onCloseForm: _ctx.onCloseEmailDialog
      }, null, 8, ["visible", "firstRecipients", "onCloseForm"])
    ]))
  ], 64))
}